import { Component } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public menus = [
    { title: 'Inbox', url: '/main/Inbox', icon: 'mail' },
    { title: 'Outbox', url: '/main/Outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/main/Favorites', icon: 'heart' },
    { title: 'Archived', url: '/main/Archived', icon: 'archive' },
    { title: 'Trash', url: '/main/Trash', icon: 'trash' },
    { title: 'Spam', url: '/main/Spam', icon: 'warning' },
  ];
  constructor() {}
}
